import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    container: {
      margin: theme.spacing(1),
      display: 'felx',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
  {
    index: 1,
  }
);
